const logos = {
    // goldText: require('./Monarch-Logo-GoldText.png'),
    greenText: require('./Monarch-Logo-GreenText-min.png'),
    // whiteText: require('./Monarch-Logo-WhiteText.png'),
};

export default logos;